const str = `


.copyrightContainer {
    width: 60%;
	margin: 50px auto;
    font-family: "Roboto";
    font-size: 16px
}
@media only screen and (max-width: 480px) {
    .copyrightContainer {
        width: 90%;
        margin-left: 15px;
        font-family: "Roboto"
    }
}
.headerContainer {
    background-color:#001F54;
    height: 200px;
    display: flex;
    justify-content: center;
	align-items: center;
	font-family: "Roboto"
}
.image{
    width: 200px
}
}`
export default str



// WEBPACK FOOTER //
// ./src/pages/PrivacyTermsPages/Copyright/styles.js